/* eslint-disable import/prefer-default-export */
export const detailTypes = {
  selectedTicket: 'Ticket especifico',
  currentTicket: 'Ticket actual',
  detailCurrentShipment: 'Detalle envio actual',
  none: 'ningún ticket',
};
